import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import asyncComponent from "../../../util/asyncComponent";

const Form = ({ match }) => (
  <div className="app-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/preguntas`} />

      <Route
        path={`${match.url}/list-preguntas`}
        component={asyncComponent(() => import("./routes/list-preguntas"))}
      />

      <Route
        component={asyncComponent(() =>
          import("app/routes/extraPages/routes/404")
        )}
      />
    </Switch>
  </div>
);

export default Form;



// WEBPACK FOOTER //
// ./app/routes/preguntas/index.js